import { useState } from "react";
import { useDispatch } from "react-redux";

import { login } from "../../redux/slice/userSlice";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { Link } from "react-router-dom";

const LoginForm = () => {
  const dispatch = useDispatch();

  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handlePasswordVisibility = (e) => {
    setPasswordVisibility((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = { email, password };
    dispatch(login(data));
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col gap-5">
        {/* Email input container */}
        <div className="flex flex-col gap-3">
          <label htmlFor="email" className="text-textPrimary font-medium ">
            Email Address*
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="login-input outline outline-[1px] outline-textSecondary/60 focus:outline-textPrimary"
            placeholder="Enter email address"
            autoFocus
            required
          />
        </div>

        {/* Password input container */}
        <div className="flex flex-col gap-3">
          <label htmlFor="password" className="text-textPrimary font-medium">
            Password*
          </label>
          <div className="block">
            <button
              type="button"
              className="absolute mt-4 sm:ml-[390px] ml-[240px] text-[12px]"
              onClick={handlePasswordVisibility}
              tabIndex="-1"
            >
              {passwordVisibility ? (
                <FaRegEye className="text-[18px]" />
              ) : (
                <FaRegEyeSlash className="text-[18px]" />
              )}
            </button>
            <input
              type={passwordVisibility ? "text" : "password"}
              id="password"
              name="password"
              className="w-full login-input outline outline-[1px] outline-textSecondary/60 focus:outline-textPrimary"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
        </div>

        {/* Remember password container */}
        <Link to="/forgot-password" className="flex self-end mr-6">
          {/* <input
            type="checkbox"
            id="rememberPassword"
            name="rememberPassword"
          /> */}
          <span className="text-secondary italic text-sm">
            Forgot password?
          </span>
        </Link>

        {/* Original with google login */}
        <div className="flex text-center flex-col gap-6">
          <button
            type="submit"
            className="h-[52px] bg-secondary rounded-md text-primary text-xl font-medium"
          >
            Login
          </button>
        </div>
      </div>
    </form>
  );
};

export default LoginForm;
